import { Pipe, PipeTransform } from '@angular/core';
import * as moment from 'moment';

@Pipe({ name: 'dateFull', pure: false })
export class DateTimeFullPipe implements PipeTransform {
  transform(value: Date) {
    if (value) {
      return moment(value).format('HH:mm DD-MM-YYYY');
    }
    return 'Chưa có thời hạn';
  }
}
